/**
 * Image Gallery Carousel — lightweight vanilla JS enhancement.
 *
 * The mobile carousel works fully via native CSS scroll-snap + touch
 * swipe without any JavaScript. This script only wires up optional
 * prev/next arrow buttons so desktop-trackpad / mouse users (or anyone
 * previewing mobile view without touch) can also step through images.
 *
 * No external libraries. No jQuery. Scoped per-section so multiple
 * instances of this section can live on the same page.
 */
(function () {
  'use strict';

  function initGalleryCarousel(section) {
    var track = section.querySelector('[data-gallery-track]');
    var prevBtn = section.querySelector('[data-gallery-prev]');
    var nextBtn = section.querySelector('[data-gallery-next]');

    if (!track || (!prevBtn && !nextBtn)) return;

    // Scroll by the width of one item (+ gap) so a click/tap advances
    // by exactly one image at a time, keeping the 2-visible layout intact.
    function getStepWidth() {
      var firstItem = track.querySelector('.gallery-carousel__item');
      if (!firstItem) return track.clientWidth / 2;

      var itemRect = firstItem.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

      return itemRect.width + gap;
    }

    function scrollByStep(direction) {
      track.scrollBy({
        left: direction * getStepWidth(),
        behavior: 'smooth'
      });
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;

      var maxScrollLeft = track.scrollWidth - track.clientWidth - 1;

      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScrollLeft;

      prevBtn.style.opacity = prevBtn.disabled ? '0.35' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '0.35' : '1';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', debounce(updateArrowState, 100), {
      passive: true
    });
    window.addEventListener('resize', debounce(updateArrowState, 150));

    updateArrowState();
  }

  // Minimal debounce helper (no lodash / external deps)
  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function initAll() {
    var sections = document.querySelectorAll('.gallery-carousel-section');
    sections.forEach(initGalleryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.gallery-carousel-section');
    if (section) initGalleryCarousel(section);
  });
})();
